import { Action } from '@ngrx/store';

export enum ChatBubbleActionTypes {
  BubbleClick = '[Omni - Chat Bubble] BubbleClick',
}

export class BubbleClick implements Action {
  readonly type = ChatBubbleActionTypes.BubbleClick;
}

export const chatBubbleActions = {
  BubbleClick,
};

export type ChatBubbleActions = BubbleClick;
